export const ACTIVITY_PROGRESS_SAVE_TIMEOUT = 5000;
export const ACTIVITY_PROGRESS_SAVE_INTERVAL = 60000;
export const DEFAULT_TOAST_TIMEOUT_MS = 3000;
